import { USER_ROLES } from "@utils/consts";

export const PROFILE_GUIDE_STEPS = {
  MENU: "profile-menu",
  AVAILABILITY: "profile-availability",
  DETAILS: "profile-details",
  NOTIFICATIONS: "profile-notifications",
  SETTINGS: "profile-settings",
  LOGOUT: "profile-logout",
};

export const isProfileMenuGuideStep = (step) =>
  Object.values(PROFILE_GUIDE_STEPS).includes(step) && step !== PROFILE_GUIDE_STEPS.MENU;

export const getNavigationGuideItems = (navItems, roles = []) => {
  if (!Array.isArray(navItems)) return undefined;
  const isCounsellor = roles.some((role) => role.name === USER_ROLES.COUNSELLOR_ROLE);
  const showNotifications = isCounsellor || roles.some((role) => role.name === USER_ROLES.ALLBRY_COUNSELLOR_ROLE);
  return [
    ...navItems.map(({ name }) => ({ name, titleKey: `navbar.${name}.title`, descriptionKey: name })),
    { name: PROFILE_GUIDE_STEPS.MENU, titleKey: "navigationGuide.profileMenu", descriptionKey: "profileMenu" },
    ...(isCounsellor ? [{ name: PROFILE_GUIDE_STEPS.AVAILABILITY, titleKey: "navigationGuide.availability", descriptionKey: "availability" }] : []),
    { name: PROFILE_GUIDE_STEPS.DETAILS, titleKey: "navbar.profile", descriptionKey: "profile" },
    ...(showNotifications ? [{ name: PROFILE_GUIDE_STEPS.NOTIFICATIONS, titleKey: "navbar.notifications.title", descriptionKey: "notifications" }] : []),
    { name: PROFILE_GUIDE_STEPS.SETTINGS, titleKey: "navbar.settings.title", descriptionKey: "settings" },
    { name: PROFILE_GUIDE_STEPS.LOGOUT, titleKey: "navbar.logOut", descriptionKey: "logOut" },
  ];
};
